export default {
  NEW: 'NEW',
  READ: 'READ',
};
